import { koComponent } from '../../../ko-utils/index';
import { ButtonBadgeDescriptor } from '../../../site-config/trackableConfig';
import { beginNoTracking, endNoTracking } from '../../../utils/changeTracking';

class BadgeDescriptor {
    constructor(params, parent) {
        this.root = params.rootElement;

        if (!this.root()) {
            this.root.noTracking = true;
            this.root(new ButtonBadgeDescriptor());
            this.root.noTracking = false;

            beginNoTracking(this.root());
            this.root().type('none');
            endNoTracking(this.root());
        }
    }
}


export default koComponent('badge-descriptor', BadgeDescriptor);